export { default as CoreBootLogoTitle } from './LogoTitle';
